/**
 * Utility method to get the base URI of the boss client
 */
export default () => process.env.BOSS_API_URL || process.env.NEXT_PUBLIC_BOSS_API_URL || '';
